import { render, staticRenderFns } from "./ResellerPlanDetail.vue?vue&type=template&id=a7b9b2be&"
import script from "./ResellerPlanDetail.vue?vue&type=script&lang=js&"
export * from "./ResellerPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResellerPlanDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports